import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';
import { DeleteIcon } from './DeleteIcon/DeleteIcon.jsx';
import { QtyControl } from './QtyControl/QtyControl.jsx';
import { ProductCell } from './ProductCell/ProductCell.jsx';
import { PriceCell } from './PriceCell/PriceCell.jsx';
import { CompareCheckbox } from './CompareCheckbox/CompareCheckbox.jsx';
import { RelatedSection } from './RelatedSection/RelatedSection.jsx';
import { DeliveryCell } from './DeliveryCell/DeliveryCell.jsx';
import { SubstitutionSectionWrapper } from './SubstitutionSection/SubstitutionSectionWrapper.jsx';
import { WeeePrices } from '../WeeePrices/weee-prices.jsx';

interface SingleItemProps {
  card: any;
  optionsStore: {
    isPriceEnabledOnSite: boolean,
    isDeliveryDisplay: boolean,
    disableSubstitutions: boolean,
    isWeeePricesVisible: boolean
  };
  labelsStore: {
    giftlistPricePeritem: string
  };
  substRootStore: {
    getSubstSectionStores: Function,
    substitutions: Array<any>
  };
  isEditable: boolean;
}

class _SingleItem extends Component<SingleItemProps> {
  static propTypes: any;
  static defaultProps: any;

  remove = () => {
    const { card } = this.props;

    card.remove(card, true);
  };

  render() {
    const { optionsStore, card, isEditable, labelsStore, substRootStore } = this.props;
    const isDisabled = card.isDisabled ? 'disabled' : '';
    const isFull = card.compareDisabled ? 'is-full' : '';

    const deliveryCell = optionsStore.isDeliveryDisplay && (
      <div className="cart-table__column cart-table__column--small deliveryDate">
        <DeliveryCell item={card} />
      </div>
    );

    const relatedSection = card.showRelatedProducts && (
      <RelatedSection skuID={card.skuID} skuCommRef={card.commRef} relatedStore={undefined} />
    );

    const isSubstitution = card.isObsolete && !optionsStore.disableSubstitutions && !!substRootStore.substitutions;

    const replacingQtyMsg = card.isShowReplacingStatus && (
      <span className="my-cart__replacing-msg">
        {card.getReplacingQtyMsg()}
      </span>
    );

    let itemClassList = `cart-table__single-item cart-table__row indent-words ${card.pendingState} ${isDisabled}`;

    if (card.hasRelatedProducts) {
      itemClassList += ' has-related';
    }

    return (
      <div className="cart-table__single-item">

        <div className={itemClassList}>

          <div className={`cart-table__column--tiny comparator ${isFull}`}>
            <CompareCheckbox card={card} />
          </div>

          <div className="cart-table__column--wide">
            <ProductCell card={card} />
          </div>

          {deliveryCell}

          <div className="cart-table__column cart-table__column--small quantity">
            <QtyControl item={card} isEditable={isEditable} />
            {replacingQtyMsg}
          </div>

          {optionsStore.isPriceEnabledOnSite && (
            <div className="cart-table__column cart-table__column--small price">
              <PriceCell item={card} measure={labelsStore.giftlistPricePeritem} />
            </div>
          )}

          {optionsStore.isWeeePricesVisible && (
            <div className="cart-table__column cart-table__column--weee-prices secondary-text">
              <WeeePrices prices={card.weeePricesData} />
            </div>
          )}

          <div className="cart-table__column cart-table__column--delete secondary-text">
            {isEditable && <DeleteIcon onClickHandler={this.remove} />}
          </div>

        </div>

        {isSubstitution && (<SubstitutionSectionWrapper parent={card} />)}
        {relatedSection}

      </div>
    );
  }
}

_SingleItem.propTypes = {
  card: propTypes.shape({
    skuID: propTypes.string.isRequired,
    quantity: propTypes.oneOfType([propTypes.number, propTypes.string]),
    href: propTypes.string.isRequired,
    price: propTypes.number,
    deliveryTime: propTypes.string,
    currency: propTypes.string,
    commDesc: propTypes.string,
    imgAlt: propTypes.string,
    imgSrc: propTypes.string,
    remove: propTypes.func,
    changeQty: propTypes.func,
    setQty: propTypes.func,
    isInComparator: propTypes.bool,
    compareDisabled: propTypes.bool,
    handleCompareCLick: propTypes.func,
    elNumberLabel: propTypes.string,
    elNumber: propTypes.string,
    pendingState: propTypes.string,
    getProductChars: propTypes.func,
    isObsolete: propTypes.bool.isRequired,
    getReplacingQtyMsg: propTypes.func.isRequired,
    hasRelatedProducts: propTypes.bool,
    isDisabled: propTypes.bool,
    showRelatedProducts: propTypes.bool,
    isShowReplacingStatus: propTypes.bool,
    commRef: propTypes.string,
    weeePricesData: propTypes.shape({
      weeePriceLabel: propTypes.string,
      weeePriceLabelMulti: propTypes.string,
      weeeLamp: propTypes.string,
      weeePackage: propTypes.string,
      weeePro: propTypes.string
    })
  }).isRequired,

  optionsStore: propTypes.shape({
    isPriceEnabledOnSite: propTypes.bool,
    isDeliveryDisplay: propTypes.bool,
    disableSubstitutions: propTypes.bool,
    isWeeePricesVisible: propTypes.bool
  }).isRequired,

  labelsStore: propTypes.shape({
    giftlistPricePeritem: propTypes.string
  }).isRequired,

  substRootStore: propTypes.shape({
    getSubstSectionStores: propTypes.func,
    substitutions: propTypes.array
  }),
  isEditable: propTypes.bool

};

_SingleItem.defaultProps = {
  isEditable: true,
  substRootStore: null
};

export const SingleItem = inject('labelsStore', 'optionsStore', 'substRootStore')(observer(_SingleItem));
